import { Component, OnInit, Injector }      from '@angular/core';
import User from 'src/app/models/User';
import { BaseComponent }                    from '../BaseComponent';

@Component({
  selector        : 'auslroma-login',
  templateUrl     : './AuslRomaLoginComponent.html',
  styleUrls       : ['./AuslRomaLoginComponent.css'],
})

export class AuslRomaLoginComponent extends BaseComponent implements OnInit {

  user            = new User();
  loading         : boolean = false;

  constructor(
              injector : Injector
              ) 
  { 
    super(injector);
  }

  ngOnInit() 
  {
   
  }

  login() 
  {
    window.open('/authportal/web/oidc/authenticate/');
  }
}
